function subpage() {
	const mainSubpage = document.querySelector('main.subpage');
	if (!mainSubpage) return;

	// Events Loading

	function get_events(termID, paged = 1) {
		if ($('#events').length) {
			const postType = $('#events').data('post-type');

			const archiveUrl = window.location.origin + window.location.pathname;

			$.ajax({
				url: '/wp-admin/admin-ajax.php',
				method: 'post',
				timeout: 10000,
				data: {
					action: 'get_events',
					post_type: postType,
					term_id: termID,
					paged: paged,
					archive_url: archiveUrl,
				},
				success: function (data) {
					$('#events').html(data);
				},
				error: function () {
					$('.ajax-info-error').slideDown();
				},
				beforeSend: function () {
					$('.ajax-info-error').slideUp();
					$('.ajax-info-loader').slideDown();
				},
				complete: function () {
					$('.ajax-info-loader').slideUp();
				},
			});
		}
	}

	// Events filtering by categories
	$('.event-category-select').on('click', function (e) {
		e.preventDefault();

		$('.event-category-select')
			.removeClass('active')
			.addClass('button-s-white-inactive');

		$(this)
			.addClass('active')
			.removeClass('button-s-white-inactive');

		const termID = $(this).data('term-id');
		get_events(termID);
	});

	// Events pager click logic
	if ($('#events').length) {
		$(document).on('click', '#events .pager a', function (e) {
			e.preventDefault();

			$('html, body').animate({
				scrollTop: $('.event-categories').offset().top,
			}, 500);

			const termID = $('.event-category-select.active').data('term-id');

			const href = $(this).attr('href');
			let paged = 1;

			if (href) {
				const match = href.match(/page\/(\d+)/) || href.match(/paged=(\d+)/);
				if (match) {
					paged = parseInt(match[1], 10);
				} else {
					const textNum = parseInt($(this).text(), 10);
					if (!isNaN(textNum)) { paged = textNum; }
				}
			}

			get_events(termID, paged);
		});
	}

	// News Loading

	function get_news(paged = 1) {
		if ($('#news').length) {
			const postType = $('#news').data('post-type');
			const termId = $('#news').data('term-id');

			const archiveUrl = window.location.origin + window.location.pathname;

			$.ajax({
				url: '/wp-admin/admin-ajax.php',
				method: 'post',
				timeout: 10000,
				data: {
					action: 'get_news',
					post_type: postType,
					term_id: termId,
					paged: paged,
					archive_url: archiveUrl,
				},
				success: function (data) {
					$('#news').html(data);
				},
				error: function () {
					$('.ajax-info-error').slideDown();
				},
				beforeSend: function () {
					$('.ajax-info-error').slideUp();
					$('.ajax-info-loader').slideDown();
				},
				complete: function () {
					$('.ajax-info-loader').slideUp();
				},
			});
		}
	}

	// News pager click logic
	if ($('#news').length) {
		$(document).on('click', '#news .pager a', function (e) {
			e.preventDefault();

			$('html, body').animate({
				scrollTop: $('#news').offset().top,
			}, 500);

			const href = $(this).attr('href');
			let paged = 1;

			if (href) {
				const match = href.match(/page\/(\d+)/) || href.match(/paged=(\d+)/);
				if (match) {
					paged = parseInt(match[1], 10);
				} else {
					const textNum = parseInt($(this).text(), 10);
					if (!isNaN(textNum)) { paged = textNum; }
				}
			}

			get_news(paged);
		});
	}

	// Knowledge Loading

	function get_knowledge(termsNames, paged = 1) {
		if ($('#knowledge').length) {
			const postType = $('#knowledge').data('post-type');

			const archiveUrl = window.location.origin + window.location.pathname;

			$.ajax({
				url: '/wp-admin/admin-ajax.php',
				method: 'post',
				timeout: 10000,
				data: {
					action: 'get_knowledge',
					post_type: postType,
					terms_names: termsNames,
					paged: paged,
					archive_url: archiveUrl,
				},
				success: function (data) {
					$('#knowledge').html(data);
				},
				error: function () {
					$('.ajax-info-error').slideDown();
				},
				beforeSend: function () {
					$('.ajax-info-error').slideUp();
					$('.ajax-info-loader').slideDown();
				},
				complete: function () {
					$('.ajax-info-loader').slideUp();
				},
			});
		}
	}

	// Knowledge filtering by categories
	$('.knowledge-category-select').on('click', function (e) {
		e.preventDefault();

		if ($(this).hasClass('clear')) {
			$('.knowledge-category-select').removeClass('active');
		} else {
			$(this).toggleClass('active');
		}

		const termsNames = $('.knowledge-category-select.active').map(function () {
			return $(this).data('term-name');
		}).get();

		history.replaceState(null, '', '#' + termsNames);

		get_knowledge(termsNames);
	});

	$('.show-all-publications').on('click', function (e) {
		e.preventDefault();

		$('html, body').animate({
			scrollTop: $('.knowledge').offset().top,
		}, 500);

		const termsNames = [];
		$('.knowledge-category-select').removeClass('active');
		get_knowledge(termsNames);
	});

	$('.show-reports').on('click', function (e) {
		e.preventDefault();

		$('html, body').animate({
			scrollTop: $('.knowledge').offset().top,
		}, 500);

		const termsNames = ['raport'];
		$('.knowledge-category-select[data-term-id=9]').addClass('active');
		get_knowledge(termsNames);
	});

	if ($('#knowledge').length) {
		$(document).on('click', '#knowledge .pager a', function (e) {
			e.preventDefault();

			$('html, body').animate({
				scrollTop: $('.knowledge').offset().top,
			}, 500);

			const termsNames = $('.knowledge-category-select.active').map(function () {
				return $(this).data('term-name');
			}).get();

			const href = $(this).attr('href');
			let paged = 1;

			if (href) {
				const match = href.match(/page\/(\d+)/) || href.match(/paged=(\d+)/);
				if (match) {
					paged = parseInt(match[1], 10);
				} else {
					const textNum = parseInt($(this).text(), 10);
					if (!isNaN(textNum)) { paged = textNum; }
				}
			}

			get_knowledge(termsNames, paged);
		});
	}

	$(document).ready(function () {

		const termsNames = window.location.hash.substring(1);

		if (termsNames) {
			console.log(termsNames);

			$('.knowledge-category-select')
			.removeClass('active');

			$('.knowledge-category-select[data-term-name="' + termsNames + '"]')
			.addClass('active');

			get_knowledge([termsNames]);
		}

	});

	// Facilities Loading

	$('.facilities-advanced-filters-select').select2({
		minimumResultsForSearch: Infinity,
	});

	function getFacilities(paged = 1) {
		if ($('#facilities').length) {

			const postType = $('#facilities').data('post-type');
			const phrase = $('.facilities-phrase').val();
			const filters = {};
			const archiveUrl = window.location.origin + window.location.pathname;

			$('.facilities-advanced-filters-select').each(function () {
				const $select = $(this);
				filters[$select.attr('name')] = $select.val();
			});

			$.ajax({
				url: '/wp-admin/admin-ajax.php',
				method: 'post',
				timeout: 10000,
				data: {
					action: 'get_facilities',
					post_type: postType,
					phrase: phrase,
					filters: filters,
					paged: paged,
					archive_url: archiveUrl,
				},
				success: function (data) {
					$('#facilities').html(data);
				},
				error: function () {
					$('.ajax-info-error').slideDown();
				},
				beforeSend: function () {
					$('.ajax-info-error').slideUp();
					$('.ajax-info-loader').slideDown();
				},
				complete: function () {
					$('.ajax-info-loader').slideUp();
				},
			});
		}
	}

	$('.facilities-filters').on('submit', function (e) {
		e.preventDefault();

		$('html, body').animate({
			scrollTop: $('.facilities-heading').offset().top,
		}, 500);

		getFacilities();
	});

	// Facilities pager click logic
	if ($('#facilities').length) {
		$(document).on('click', '#facilities .pager a', function (e) {
			e.preventDefault();

			$('html, body').animate({
				scrollTop: $('.facilities-heading').offset().top,
			}, 500);

			const href = $(this).attr('href');
			let paged = 1;

			if (href) {
				const match = href.match(/page\/(\d+)/) || href.match(/paged=(\d+)/);
				if (match) {
					paged = parseInt(match[1], 10);
				} else {
					const textNum = parseInt($(this).text(), 10);
					if (!isNaN(textNum)) { paged = textNum; }
				}
			}

			getFacilities(paged);
		});
	}

	// Companies Loading

	$('.companies-advanced-filters-select').select2({
		minimumResultsForSearch: Infinity,
	});

	$('.companies-sort-select').select2({ minimumResultsForSearch: Infinity });

	function getCompanies(paged = 1) {
		if ($('#companies-list').length) {

			const postType = $('#companies-list').data('post-type');
			const phrase = $('.companies-phrase').val();
			const sort = $('.companies-sort-select').val();
			const filters = {};
			const archiveUrl = window.location.origin + window.location.pathname;

			$('.companies-advanced-filters-select').each(function () {
				const $select = $(this);
				filters[$select.attr('name')] = $select.val();
			});

			$.ajax({
				url: '/wp-admin/admin-ajax.php',
				method: 'post',
				timeout: 10000,
				data: {
					action: 'get_companies',
					post_type: postType,
					phrase: phrase,
					sort: sort,
					filters: filters,
					paged: paged,
					archive_url: archiveUrl,
				},
				success: function (data) {
					$('#companies-list').html(data);
				},
				error: function () {
					$('.ajax-info-error').slideDown();
				},
				beforeSend: function () {
					$('.ajax-info-error').slideUp();
					$('.ajax-info-loader').slideDown();
				},
				complete: function () {
					$('.ajax-info-loader').slideUp();
				},
			});
		}
	}

	// Trigger AJAX instantly when sorting changes
	$('.companies-sort-select').on('change', function () {
		getCompanies();
	});

	// Companies form submit listener
	$('.companies-filters').on('submit', function (e) {
		e.preventDefault();

		$('html, body').animate({
			scrollTop: $('.companies-heading').offset().top,
		}, 500);

		getCompanies();
	});

	// Companies pager click logic
	if ($('#companies-list').length) {
		$(document).on('click', '#companies-list .pager a', function (e) {
			e.preventDefault();

			$('html, body').animate({
				scrollTop: $('.companies-heading').offset().top,
			}, 500);

			const href = $(this).attr('href');
			let paged = 1;

			if (href) {
				const match = href.match(/page\/(\d+)/) || href.match(/paged=(\d+)/);
				if (match) {
					paged = parseInt(match[1], 10);
				} else {
					const textNum = parseInt($(this).text(), 10);
					if (!isNaN(textNum)) { paged = textNum; }
				}
			}

			getCompanies(paged);
		});
	}
}
